if ( typeof cartShippingEstimate !== 'function' ) {

	document.addEventListener('alpine:init', () => {
		if (!Alpine.store('cartShipping')) {
			Alpine.store('cartShipping', { priceRaw: null, name: '' });
		}
	});

	window.cartShippingEstimate = function cartShippingEstimate() {
		return {
			state: 'empty',
			zip: '',
			zipInput: '',
			street: '',
			error: '',
			loading: false,
			rates: [],
			selectedIndex: 0,
			expanded: true,

			init() {
				const initial = this.$el.dataset.initialZip;
				if (initial) {
					this.zipInput = initial;
					this.calculate();
				}
			},

			get visibleRates() {
				const withIndex = this.rates.map((r, i) => ({ ...r, __index: i }));
				if (this.expanded) return withIndex;
				return withIndex.filter(r => r.__index === this.selectedIndex);
			},

			get selectedRate() {
				return this.rates[this.selectedIndex] || null;
			},

			get selectedRateLabel() {
				return this.selectedRate ? this.selectedRate.delivery_days : '';
			},

			get selectedRatePrice() {
				return this.selectedRate ? this.selectedRate.price_formatted : '';
			},

			select(index) {
				this.selectedIndex = index;
				this.publishSelection();
			},

			publishSelection() {
				const selected = this.rates[this.selectedIndex];
				if (selected && Alpine.store('cartShipping')) {
					Alpine.store('cartShipping').priceRaw = selected.price_raw;
					Alpine.store('cartShipping').name = selected.name;
				}
			},

			expand() {
				this.expanded = true;
				this.state = 'result';
			},

			collapse() {
				this.state = 'summary';
			},

			maskCEP() {
				let v = this.zipInput.replace(/\D/g, '').slice(0, 8);
				v = v.replace(/^(\d{5})(\d)/, '$1-$2');
				this.zipInput = v;
			},

			edit() {
				this.zipInput = this.zip;
				this.state = 'empty';
				this.expanded = true;
				this.error = '';
				this.street = '';
				if (Alpine.store('cartShipping')) {
					Alpine.store('cartShipping').priceRaw = null;
				}
			},

			async calculate() {
				const cleanZip = this.zipInput.replace(/\D/g, '');
				if (cleanZip.length !== 8) {
					this.error = 'CEP inválido';
					return;
				}
				this.error = '';
				this.loading = true;
				this.state = 'loading';
				this.zip = this.zipInput;

				try {
					const cepData = await fetch('https://viacep.com.br/ws/' + cleanZip + '/json/').then(r => r.json());
					if (cepData.erro || !cepData.uf) {
						this.error = 'CEP não encontrado';
						this.state = 'empty';
						this.loading = false;
						return;
					}

					this.street = cepData.logradouro || '';

					const states = {
						AC:'Acre',AL:'Alagoas',AP:'Amapá',AM:'Amazonas',BA:'Bahia',CE:'Ceará',
						DF:'Distrito Federal',ES:'Espírito Santo',GO:'Goiás',MA:'Maranhão',
						MT:'Mato Grosso',MS:'Mato Grosso do Sul',MG:'Minas Gerais',PA:'Pará',
						PB:'Paraíba',PR:'Paraná',PE:'Pernambuco',PI:'Piauí',RJ:'Rio de Janeiro',
						RN:'Rio Grande do Norte',RS:'Rio Grande do Sul',RO:'Rondônia',RR:'Roraima',
						SC:'Santa Catarina',SP:'São Paulo',SE:'Sergipe',TO:'Tocantins'
					};

					const params = new URLSearchParams({
						'shipping_address[country]': 'Brazil',
						'shipping_address[province]': states[cepData.uf] || '',
						'shipping_address[zip]': cleanZip
					});

					const data = await fetch('/cart/shipping_rates.json?' + params.toString()).then(r => r.json());

					const mapped = (data.shipping_rates || []).map(r => ({
						name: r.presentment_name || r.name,
						price_raw: Number(r.price),
						price_formatted: 'R$ ' + Number(r.price).toFixed(2).replace('.', ','),
						delivery_days: (r.delivery_days && r.delivery_days.length)
							? 'até ' + (r.delivery_days[1] + 1) + ' dias úteis'
							: ''
					}));

					mapped.sort((a, b) => a.price_raw - b.price_raw);
					this.rates = mapped;
					this.selectedIndex = 0;
					this.expanded = true;
					this.state = 'summary';
					this.publishSelection();
				} catch (e) {
					console.error('cart-shipping-estimate:', e);
					this.error = 'Erro ao calcular o frete. Tente novamente.';
					this.state = 'empty';
				} finally {
					this.loading = false;
				}
			}
		};
	}

}

if ( typeof CartForm !== 'function' ) {
	class CartForm extends HTMLElement {

		constructor(){
			super();
			this.ajaxifyCartItems();
		}

		ajaxifyCartItems(){

			this.form = this.querySelector('form');

			this.querySelectorAll('[data-js-cart-item]').forEach(item=>{

				const remove = item.querySelector('.remove');
				if ( remove ) {
					remove.dataset.href = remove.getAttribute('href');
					remove.setAttribute('href', '');
					remove.addEventListener('click', (e)=>{
						e.preventDefault();
						this.updateCartQty(item, 0);
					})
				}

				const qty = item.querySelector('.qty');
				if ( qty ) {
					qty.addEventListener('input', debounce(e=>{
						e.preventDefault();
						e.target.blur();
						this.updateCartQty(item, parseInt(qty.value));
					}, 500));
					qty.addEventListener('click', (e)=>{
						e.target.select();
					})
				}

			})

		}

		updateCartQty(item, newQty){

			let alert = null;

			this.form.classList.add('processing');
			if ( this.querySelector('.alert') ) {
				this.querySelector('.alert').remove();
			}

			const body = JSON.stringify({
				line: parseInt(item.dataset.line),
				quantity: newQty
			});

			fetch(KROWN.settings.routes.cart_change_url, {
					method: 'POST',
					headers: { 'Content-Type': 'application/json', 'Accept': 'application/javascript' },
					body
				})
				.then(response => response.json())
				.then(response => {
					if ( response.status == 422 ) {
						alert = document.createElement('span');
						alert.classList.add('alert', 'alert--error');
						if ( typeof response.description === 'string' ) {
							alert.innerHTML = response.description;
						} else {
							alert.innerHTML = response.message;
						}
					}
					return fetch('?section_id=helper-cart');
				})
				.then(response => response.text())
				.then(text => {

					const sectionInnerHTML = new DOMParser().parseFromString(text, 'text/html');
					const cartFormInnerHTML = sectionInnerHTML.getElementById('AjaxCartForm').innerHTML;
					const cartSubtotalInnerHTML = sectionInnerHTML.getElementById('AjaxCartSubtotal').innerHTML;

					const cartItems = document.getElementById('AjaxCartForm');
					cartItems.innerHTML = cartFormInnerHTML;
					cartItems.ajaxifyCartItems();

					document.querySelectorAll('[data-header-cart-count]').forEach(elm=>{
						elm.textContent = cartItems.querySelector('[data-cart-count]').textContent;
					});
					document.querySelectorAll('[data-header-cart-total').forEach(elm=>{
						elm.textContent = cartItems.querySelector('[data-cart-total]').textContent;
					});

					if ( alert !== null ) {
						this.form.prepend(alert);
					} 

					document.getElementById('AjaxCartSubtotal').innerHTML = cartSubtotalInnerHTML;
					if ( window.Alpine ) {
						Alpine.initTree(document.getElementById('AjaxCartSubtotal'));
					}

					const upsellSrc = sectionInnerHTML.getElementById('CartUpsellProtetorSolar');
					const upsellDst = document.getElementById('CartUpsellProtetorSolar');
					if ( upsellSrc && upsellDst ) { upsellDst.innerHTML = upsellSrc.innerHTML; }

					// Card Aula Master (minicart) — ver snippets/cart-aula-master.liquid
					if ( window.syncAulaMaster ) { window.syncAulaMaster(sectionInnerHTML); }

					const event = new Event('cart-updated');
					this.dispatchEvent(event);

				})
				.catch(e => {
					console.log(e);
					let alert = document.createElement('span');
					alert.classList.add('alert', 'alert--error');
					alert.textContent = KROWN.settings.locales.cart_general_error;
					this.form.prepend(alert);
				})
				.finally(() => {
					this.form.classList.remove('processing');
				});
		}

	} 


  if ( typeof customElements.get('cart-form') == 'undefined' ) {
		customElements.define('cart-form', CartForm);
	}

}

if ( typeof CartProductQuantity !== 'function' ) {

	class CartProductQuantity extends HTMLElement {
		constructor(){
			super();
			this.querySelector('.qty-minus').addEventListener('click', this.changeCartInput.bind(this));
			this.querySelector('.qty-plus').addEventListener('click', this.changeCartInput.bind(this));
		}
		changeCartInput(){
			setTimeout(()=>{
				document.getElementById('AjaxCartForm').updateCartQty(this.closest('[data-js-cart-item]'), parseInt(this.querySelector('.qty').value));
			}, 50);
		}
	}

  if ( typeof customElements.get('cart-product-quantity') == 'undefined' ) {
		customElements.define('cart-product-quantity', CartProductQuantity);
	}

}

if ( ! window.refreshCart ) {

	window.refreshCart = () => {
		
		fetch('?section_id=helper-cart')
			.then(response => response.text())
			.then(text => {

		const sectionInnerHTML = new DOMParser().parseFromString(text, 'text/html');
		const cartFormInnerHTML = sectionInnerHTML.getElementById('AjaxCartForm').innerHTML;
		const cartSubtotalInnerHTML = sectionInnerHTML.getElementById('AjaxCartSubtotal').innerHTML;

		const cartItems = document.getElementById('AjaxCartForm');
		cartItems.innerHTML = cartFormInnerHTML;
		cartItems.ajaxifyCartItems();

		document.querySelectorAll('[data-header-cart-count]').forEach(elm=>{
			elm.textContent = cartItems.querySelector('[data-cart-count]').textContent;
		});
		document.querySelectorAll('[data-header-cart-total').forEach(elm=>{
			elm.textContent = cartItems.querySelector('[data-cart-total]').textContent;
		})
		
		document.getElementById('AjaxCartSubtotal').innerHTML = cartSubtotalInnerHTML;
		if ( window.Alpine ) {
			Alpine.initTree(document.getElementById('AjaxCartSubtotal'));
		}

		const upsellSrc = sectionInnerHTML.getElementById('CartUpsellProtetorSolar');
		const upsellDst = document.getElementById('CartUpsellProtetorSolar');
		if ( upsellSrc && upsellDst ) { upsellDst.innerHTML = upsellSrc.innerHTML; }

		// Card Aula Master (minicart) — ver snippets/cart-aula-master.liquid
		if ( window.syncAulaMaster ) { window.syncAulaMaster(sectionInnerHTML); }

		if ( document.querySelector('[data-js-site-cart-sidebar]') ) {
			document.querySelector('[data-js-site-cart-sidebar]').show();
		}

		if ( document.querySelector('cart-recommendations') ) {
			document.querySelector('cart-recommendations').innerHTML = '';
			document.querySelector('cart-recommendations').generateRecommendations();
		}

	})

}

}

if ( ! customElements.get('cart-note') ) {
  customElements.define(
    'cart-note',
    class CartNote extends HTMLElement {
      constructor() {
        super();
        this.addEventListener(
          'input',
          debounce(event => {
            const body = JSON.stringify({ note: event.target.value });
            fetch(`${KROWN.settings.routes.cart_update_url}`, { 
							method: 'POST',
							headers: { 'Content-Type': 'application/json', 'Accept': 'application/javascript' },
							body 
						});
		  		}, 150)
				);
      }
    }
  );
}

if ( ! customElements.get('cart-discounts' ) ) {
	customElements.define(
		'cart-discounts',
		class CartDiscounts extends HTMLElement {

			constructor() {
				super();

				const button = this.querySelector('[data-js-discount-submit]');
				this.input = this.querySelector('[data-js-discount-input]');
				this.cartSubtotal = document.getElementById('AjaxCartSubtotal');
				this.cartDiscountError = this.querySelector('[data-js-discount-error]');
				this.discountCodes = document.querySelector('[data-js-discount-codes]');

				this.loadDiscountButtons();

				button.addEventListener('click', (e) => {
					e.preventDefault();
					if ( this.input.value.length > 0 ) {

						this.cartSubtotal.classList.add('processing');
						this.discountCodes.classList.add('processing');

						const existingDiscounts = Array.from(this.querySelectorAll('[data-js-discount]')).map(elm => elm.dataset.jsDiscount);
						
						const allDiscounts = [...existingDiscounts, this.input.value];
						const discountString = allDiscounts.join(',');
						const body = JSON.stringify({ discount: discountString });

						fetch(`${KROWN.settings.routes.cart_update_url}`, { 
							method: 'POST',
							headers: { 'Content-Type': 'application/json', 'Accept': 'application/javascript' },
							body 
						})
							.then(response => response.json())
							.then(response => {
								const discountCodes = response.discount_codes;
								const inputValue = this.input.value;
								const matchingCode = discountCodes.find(code => 
									code.code === inputValue
								);

								/*
								 * FIX — cupons que zeram 100% do carrinho: a Shopify por vezes retorna
								 * "applicable: false" para esse tipo de desconto mesmo com o valor ja
								 * aplicado de fato no total (quirk conhecido da API de cart quando o
								 * total chega a zero). Usar so a presenca do codigo em discount_codes
								 * (ou seja, a Shopify reconheceu/aceitou o cupom) evita falso-negativo
								 * nesses casos, sem deixar de rejeitar codigo realmente invalido
								 * (que nem aparece em discount_codes).
								 */
								if (matchingCode) {
									this.handleSuccess();
								} else {
									this.handleError();
								}
							})
							.catch(error => {
								this.handleError();
								console.log(`Error: ${error}`);
							})

					}

				});

			}

			handleSuccess(){
				fetch('?section_id=helper-cart')
					.then(response => response.text())
					.then(text => {
						const sectionInnerHTML = new DOMParser().parseFromString(text, 'text/html');
						const cartSubtotalInnerHTML = sectionInnerHTML.getElementById('AjaxCartSubtotal').innerHTML;

						const cartFormSection = sectionInnerHTML.getElementById('AjaxCartForm');
						const cartItems = document.getElementById('AjaxCartForm');
						if ( cartFormSection && cartItems ) {
							cartItems.innerHTML = cartFormSection.innerHTML;
							cartItems.ajaxifyCartItems();

							document.querySelectorAll('[data-header-cart-count]').forEach(elm=>{
								elm.textContent = cartItems.querySelector('[data-cart-count]').textContent;
							});
							document.querySelectorAll('[data-header-cart-total').forEach(elm=>{
								elm.textContent = cartItems.querySelector('[data-cart-total]').textContent;
							});
						}

						this.cartSubtotal.innerHTML = cartSubtotalInnerHTML;
						if ( window.Alpine ) {
							Alpine.initTree(this.cartSubtotal);
						}
						this.cartSubtotal.classList.remove('processing');
						this.cartDiscountError.innerHTML = '';
						if ( sectionInnerHTML.querySelector('[data-js-discount-codes]') ) {
							this.discountCodes.innerHTML = sectionInnerHTML.querySelector('[data-js-discount-codes]').innerHTML;
							this.discountCodes.classList.remove('processing');
							this.loadDiscountButtons();
						}
						this.input.value = '';

						/*
						 * UPSELL — Protetor Solar (sync pós aplicar/remover cupom)
						 * Mesma re-hidratação do #CartUpsellProtetorSolar feita em updateCartQty()
						 * e window.refreshCart() acima.
						 */
						const upsellSrc = sectionInnerHTML.getElementById('CartUpsellProtetorSolar');
						const upsellDst = document.getElementById('CartUpsellProtetorSolar');
						if ( upsellSrc && upsellDst ) { upsellDst.innerHTML = upsellSrc.innerHTML; }

						// Card Aula Master (minicart) — ver snippets/cart-aula-master.liquid
						if ( window.syncAulaMaster ) { window.syncAulaMaster(sectionInnerHTML); }

						const event = new Event('cart-updated');
						this.dispatchEvent(event);
					})
			}

			loadDiscountButtons(){
				this.querySelectorAll('[data-js-discount]').forEach(elm=>{
					if ( ! elm.classList.contains('enabled') ) {
						elm.classList.add('enabled');
						elm.addEventListener('click', (e)=>{
							e.preventDefault();
							this.cartSubtotal.classList.add('processing');
							this.discountCodes.classList.add('processing');
							const discountToRemove = elm.dataset.jsDiscount;
							
							const allDiscountElements = this.querySelectorAll('[data-js-discount]');
							const allDiscounts = Array.from(allDiscountElements).map(el => el.dataset.jsDiscount);
							
							const remainingDiscounts = allDiscounts.filter(discount => discount !== discountToRemove);
							
							const body = JSON.stringify({ 
								discount: remainingDiscounts.join(',') 
							});
							
							fetch(`${KROWN.settings.routes.cart_update_url}`, { 
								method: 'POST',
								headers: { 'Content-Type': 'application/json', 'Accept': 'application/javascript' },
								body 
							})
								.then(() => {
									this.handleSuccess();
								})
								.catch(error => {
									console.error(`Error: ${error}`);
								});
						});
					}
				});
			}
			
			handleError(){
				this.cartSubtotal.classList.remove('processing');
				this.discountCodes.classList.remove('processing');
				this.cartDiscountError.innerHTML = window.KROWN.settings.locales.cart_discount_code_error;
			}

		}	
	)
}